define('taoQtiItem/qtiCreator/model/choices/SimpleAssociableChoice',['lodash', 'taoQtiItem/qtiCreator/model/mixin/editable', 'taoQtiItem/qtiItem/core/choices/SimpleAssociableChoice'], function(_, editable, Choice){
    "use strict";
    var methods = {};
    _.extend(methods, editable);
    _.extend(methods, {
        getDefaultAttributes : function(){
            return {
                'fixed' : false,
                'showHide' : 'show',
                'matchMax' : 0,
                'matchMin' : 0
            };
        }
    });
    return Choice.extend(methods);
});
